export default __webpack_public_path__ + "static/hospitality-booking-system-b1a73da15950a72c8ff95401adbd34a7.png";